<template>
    <div class="scoreboard-phonemic-consonant">
        <span class="scoreboard-phonemic-consonant__text">{{ currentScore }}/3</span>
        <div class="scoreboard-phonemic-consonant__indicators">
            <span
                v-for="correctness, index in sortedScorelist" :key="index"
                class="scoreboard-phonemic-consonant__indicator"
                :class="[
                    correctness === 1 ? 'scoreboard-phonemic-consonant__indicator--correct'   : '',
                    correctness === 0 ? 'scoreboard-phonemic-consonant__indicator--incorrect' : '',
                ]"></span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            scorelist: { type: Array, default: [-1, -1, -1] },
        },

        computed: {
            currentScore(){
                let currentScore = 0;

                this.scorelist.forEach( correctness => {
                    if(correctness === 1){ currentScore++; }
                });

                return currentScore;
            },

            sortedScorelist(){
                return this.scorelist.sort((a, b) => b - a);
            }
        }
    };
</script>

<style scoped src="@/css/components/scoreboard-phonemic-consonant.css"></style>